import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "percentage",
    standalone: false
})
export class PercentagePipe implements PipeTransform {
	transform(value: number | null | undefined): string {
		if (value === null || value === undefined || isNaN(value)) {
			return "-";
		}
		return `${value}%`;
	}
}
